<template>
	<div class="cell-card-list">
		<div
			class="item"
			v-for="item in data"
			:key="item.id"
			@click="handleItem(item)"
		>
			<div class="left">
				<div>
					<p class="title">{{ item.goods_subtitle }}</p>
					<p class="subhead">{{ item.goods_name }}</p>

				</div>
				<p class="num fa fa-heart">{{ item.goods_vr_sale_count }}人测过</p>
			</div>
			<div class="right">
				<van-image
					fit="cover"
					:src="item.goods_cover_image"
				>
				</van-image>
			</div>
		</div>
	</div>
</template>

<script>
import { useRouter } from "vue-router";
export default {
	name: "CellCardList",
	props: {
		data: {
			type: Array,
			default: () => [],
		},
		clickItem: {
			type: Function
		}
	},
	setup(props) {
		const router = useRouter();
		function handleItem({ guid }) {

			if (props.clickItem) {
				return props.clickItem({ guid })
			}

			router.push({
				path: "/goods",
				query: {
					guid,
				},
			});
		}
		return {
			handleItem,
		};
	},
};
</script>

<style lang="less" scoped>
.cell-card-list {
	.item {
		padding: @padding-sm;
		border-radius: 3px;
		box-shadow: 0px 0px 6px #e8e8e8;
		margin-bottom: @padding-base;
		.pointer();
		.space-between();

		.left {
			flex: 1;
		}

		.right {
			width: 90px;
			height: 90px;

			.van-image {
				width: 100%;
				height: 100%;

				:deep(img) {
					border-radius: @radius-base;
				}
			}
		}

		.left {
			font-size: @font-size-lg;
			width: 200px;
			.column-space-between();

			.title {
				font-weight: bold;
			}

			.subhead {
				color: @gray-color;
				font-size: @font-size-base;
			}

			.num {
				font-size: @font-size-sm;

				&::before {
					color: @theme-color;
					padding-right: 5px;
				}
			}
		}
	}
}
</style>